import React, { useContext } from 'react'
import classnames from 'classnames'
import { PaymentFormContext } from './GpiWrapper'

// Allow any component to render the GPI payment form fields
// these fields are styled via:
// (1) `gpi-wrapper` class in _forms.scss
// (2) the `style` object passed to the form configuration in GpiWrapper
export default function GpiSubmit() {
  // PaymentFormContext comes with a several keys:
  // (1) `formErrors`: an object with error messages for any invalid payment fields
  // (2) `hasBeenSubmitted`: a boolean indicating whether the form has been submitted by the user
  // (3) `arePaymentFieldsLoading`: a boolean indicating whether the payment form JavaScript is loading
  // (4) `isDisabled`:a boolean indicating whether the GPI payments experience is currently disabled to the user
  const { arePaymentFieldsLoading, isDisabled } = useContext(PaymentFormContext)
  return (
    <div
      className={classnames('gpi-wrapper', {
        'gpi-wrapper--disabled': arePaymentFieldsLoading || isDisabled,
      })}
    >
      {/* GPI JavaScript library uses this anchor to render the Submit button that triggers tokenization */}
      <div id="submit" />
    </div>
  )
}

export function gpiSubmitStyles({ isFoundation, isDisabled }) {
  return {
    button: {
      'background-color': isFoundation ? '#e99e26' : '#5c9632',
      color: isFoundation ? 'black' : 'white',
      'font-size': '18px',
      'font-weight': isFoundation ? 'bold' : 'normal',
      'border-radius': '30px',
      'align-items': 'flex-end',
      width: '200px',
      border: '0',
      'text-transform': 'capitalize',
      padding: '10px 20px',
      'box-shadow': 'none',
      'text-decoration': 'none',
      opacity: isDisabled ? '0.4' : '1.0',
      'pointer-events': isDisabled ? 'none' : 'auto',
    },
    'button:hover': {
      cursor: 'pointer',
      'background-color': isFoundation ? '#c88314' : '#467326',
    },
  }
}
